// extracted by mini-css-extract-plugin
export var postNav = "postNav-module--postNav--2F-Im";
export var navBar = "postNav-module--navBar--2deCT";
export var singleBtn = "postNav-module--singleBtn--22tLy";